import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { PAReviewModule } from "@/store/modules/paReview.module";
let ReviewTracker = /** @class */ (() => {
    let ReviewTracker = class ReviewTracker extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.nudgeHistory = [
                {
                    stepName: "Employee",
                    nudgeDates: "14 Mar 2023",
                },
                {
                    stepId: 100,
                    stepName: "Manager",
                    nudgeDates: "25 Mar 2023",
                },
                {
                    stepId: 101,
                    stepName: "HR",
                    nudgeDates: "18 Feb 2023",
                },
                {
                    stepId: 102,
                    stepName: "COO",
                    nudgeDates: undefined,
                },
                {
                    stepId: 103,
                    stepName: "Client",
                    nudgeDates: "20 Mar 2023",
                },
            ];
        }
        closeReviewTracker() {
            this.$emit("close-review-tracker");
        }
        get memberCards() {
            if (this.statusHistoryDetails.length === 3) {
                return "three-card";
            }
            else if (this.statusHistoryDetails.length === 4) {
                return "four-card";
            }
            else if (this.statusHistoryDetails.length === 5) {
                return "five-card";
            }
            else if (this.statusHistoryDetails.length === 6) {
                return "six-card";
            }
            else if (this.statusHistoryDetails.length === 7) {
                return "seven-card";
            }
        }
        get reviewDetail() {
            return PAReviewModule.reviewDetail;
        }
        get statusHistoryDetails() {
            return PAReviewModule.reviewDetail?.reviewStatusHistoryDetails;
        }
        get paAdminNudgeHistory() {
            return PAReviewModule.paAdminNudgeHistory;
        }
        get canVieNudgeHistory() {
            return this.rightsHelper(this.rightsConstant.Reviews.CanViewNudgeHistory());
        }
        showNudgeHistory() {
            PAReviewModule.GettingPAAdminNudgeHistory(this.reviewDetail.reviewCycleId);
        }
    };
    ReviewTracker = __decorate([
        Component({
            name: "ReviewTracker",
            components: {
                Loader,
            },
        })
    ], ReviewTracker);
    return ReviewTracker;
})();
export default ReviewTracker;
